/**
 * Yüklenen dosyaların (foto/video/belge) görüntüleme URL'i.
 *
 * NEDEN GEREKLİ — sessiz 401 tuzağı:
 * Backend medya yollarını `/uploads/...` olarak üretir (örn. faaliyet medyası,
 * park fotoğrafı, revize eki). Ancak oturum çerezi `pb_access` HttpOnly ve
 * **path=/api** ile yazılır (backend/shared/cookies.py). Tarayıcı `<img
 * src="/uploads/...">` isteğine bu çerezi EKLEMEZ; istek kimliksiz gider ve
 * `_serve_authorized_upload` 401 döner. `<img>` hata verdiği için ekranda
 * çoğu yerde siyah/boş bir kutu görünür — konsola bakılmadıkça yetki sorunu
 * gibi durur, oysa istek hiç kimlik taşımamıştır.
 *
 * Backend aynı dosyayı `/api/uploads/...` ucundan da sunar (aynı ACL, aynı
 * kapsam kontrolü). Çerez oraya gittiği için görüntüleme yalnız o yolda
 * çalışır. Bu yüzden medya URL'i EKRANA BASILMADAN ÖNCE buradan geçmelidir.
 *
 * @param {string} apiBase Backend kökü (config.js → BACKEND_URL; dev'de "").
 * @param {string} url     Backend'in verdiği yol ("/uploads/...") veya mutlak URL.
 * @returns {string} Tarayıcının kimlikli olarak isteyebileceği URL.
 */
export function mediaUrl(apiBase, url) {
  if (!url) return "";
  // Mutlak adres (S3/CDN vb.) — dokunma.
  if (/^https?:/i.test(url)) return url;
  // data:/blob: (henüz yüklenmemiş yerel önizleme) — dokunma.
  if (/^(data|blob):/i.test(url)) return url;

  const path = url.startsWith("/uploads/")
    ? url.replace("/uploads/", "/api/uploads/")
    : url;
  const base = apiBase || "";
  return `${base}${path.startsWith("/") ? "" : "/"}${path}`;
}

export default mediaUrl;
